import React from 'react';
import {SidebarBanner} from 'app/components/banner/SidebarBanner';
import {useDispatch, useSelector} from 'react-redux';
import {updateNotificationNoSupportBanner} from 'app/actions/currentUserActions';
import {selectCurrentUser} from 'app/hooks/reduxCreateSelectorHooks';
import {getUserAgentData} from 'app/helpers/helpers';
import {APPLE_APP_STORE_URL} from 'app/components/banner/notificationVars';
import {useNative} from 'app/contexts/NativeContext';

const NotSupportedBanner = () => {
  const dispatch = useDispatch();
  const {notificationNoSupportBanner, notificationPermission} = useSelector(selectCurrentUser);
  const {deviceType, platform} = getUserAgentData();
  const {isFlutter} = useNative();

  const handleClose = () => {
    dispatch(updateNotificationNoSupportBanner());
  };

  if (deviceType === 'desktop') {
    const primaryAction = {label: 'Verstanden', action: handleClose};
    const text =
      'Dein Browser unterstützt keine Push-Benachrichtigungen. Installiere einen unterstützten Browser, wie Google Chrome oder Firefox.';
    return <SidebarBanner primaryAction={primaryAction} text={text} show={notificationNoSupportBanner === 0} />;
  }

  if (isFlutter && notificationPermission === 'unsupported') {
    const primaryAction = {label: 'Verstanden', action: handleClose};
    const text = 'Dein Gerät unterstützt keine Push-Benachrichtigungen.';
    return <SidebarBanner primaryAction={primaryAction} text={text} show={notificationNoSupportBanner === 0} />;
  }

  const handleAppStoreLink = () => {
    window.open(APPLE_APP_STORE_URL, '_blank');
    dispatch(updateNotificationNoSupportBanner());
  };

  let primaryAction = {label: 'App Store öffnen', action: handleAppStoreLink};
  let secondaryAction = {label: 'Schliessen', action: handleClose};

  if (platform !== 'iOS') {
    primaryAction = {label: 'Verstanden', action: handleClose};
    secondaryAction = null;
  }

  const text = 'Installiere die App aus dem App Store, um Push-Benachrichtigungen zu erhalten.';
  return (
    <SidebarBanner
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      text={text}
      show={notificationNoSupportBanner === 0}
    />
  );
};

export {NotSupportedBanner};
